<script lang="ts">
  import { leaderboardOptIn, leaderboardOptOut } from '$lib/api/studentActions';
  import type { OptInOutDirection } from '$lib/componentTypes';
  import FormModal from '../common/modal/FormModal.svelte';

  interface Props {
    classId: number;
    optIn: OptInOutDirection;
    onClose?: () => void;
  }

  let { classId, onClose, optIn = $bindable() }: Props = $props();
</script>

<FormModal
  formId="opt_in_out_confirm"
  onclose={() => {
    optIn = null;
    onClose?.();
  }}
  header={optIn === 'in' ? 'Opt in to leaderboard' : 'Opt out of leaderboard'}
  submitBtnLabel={optIn === 'in' ? 'Opt in' : 'Opt out'}
  invalidateUrl={url => url.pathname.startsWith(`/api/studentactions/classes/${classId}`)}
  onsubmit={async () => {
    if (optIn === 'in') {
      await leaderboardOptIn(classId);
    } else {
      await leaderboardOptOut(classId);
    }
    return true;
  }}
>
  {#if optIn === 'in'}
    <p>
      Do you want to opt in to the class leaderboard? Earn points and compete with the rest of your class. Your rank and 
      score will be shared with the rest of the class if you rank in the top 10 places. Participation is not required. 
      Not participating in the leaderboard does not affect your grade. You can opt in or out at any time.
    </p>
  {:else}
    <p>
      Do you want to opt out of the class leaderboard? Earn points and compete with the rest of your class. Your rank 
      and score will no longer be shared with the rest of the class. Participation is not required. Not participating in
      the leaderboard does not affect your grade. You can opt in at any time.
    </p>
  {/if}
</FormModal>
